import React from "react";
import { NavLink, useNavigate, Outlet } from "react-router-dom";
import { LayoutDashboard, FileText, FolderOpen, MessageSquare, User, LogOut, Home, Gift } from "lucide-react";
import { Logo } from "@/components/site/Logo";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";

const links = [
  { to: "/portal", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/portal/applications", label: "Applications", icon: FileText },
  { to: "/portal/documents", label: "Documents", icon: FolderOpen },
  { to: "/portal/messages", label: "Messages", icon: MessageSquare },
  { to: "/portal/referrals", label: "Referrals", icon: Gift },
  { to: "/portal/profile", label: "Profile", icon: User },
];

export default function PortalLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-obsidian flex flex-col lg:flex-row">
      <aside className="lg:w-64 lg:min-h-screen border-b lg:border-b-0 lg:border-r border-edge bg-charcoal/60 flex lg:flex-col">
        <div className="p-5 border-b border-edge hidden lg:block"><Logo size={38} showText={false} /></div>
        <nav className="flex lg:flex-col gap-1 p-3 overflow-x-auto flex-1">
          {links.map((l) => (
            <NavLink key={l.to} to={l.to} end={l.end} data-testid={`portal-nav-${l.label.toLowerCase()}`}
              className={({ isActive }) => `flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm font-semibold whitespace-nowrap transition-colors ${isActive ? "bg-gold/15 text-gold" : "text-white/75 hover:bg-surface hover:text-white"}`}>
              <l.icon className="w-4.5 h-4.5 w-5 h-5" /> {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t border-edge hidden lg:block">
          <button onClick={() => navigate("/")} className="flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm text-white/60 hover:text-gold w-full"><Home className="w-4 h-4" /> Public Site</button>
          <button onClick={logout} className="flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm text-white/60 hover:text-brandred w-full" data-testid="portal-logout"><LogOut className="w-4 h-4" /> Sign Out</button>
        </div>
      </aside>
      <div className="flex-1 min-w-0">
        <header className="flex items-center justify-between px-5 py-4 border-b border-edge lg:hidden">
          <Logo size={32} showText={false} />
          <Button variant="ghost" size="sm" onClick={logout} className="text-white/60"><LogOut className="w-4 h-4" /></Button>
        </header>
        <main className="p-5 sm:p-8 max-w-5xl mx-auto">
          <Outlet context={{ user }} />
        </main>
      </div>
    </div>
  );
}
